import { Capacitor } from '@capacitor/core';
import type { ErrorTrackerConfig } from './types';

declare const __BUILD_TIMESTAMP__: string;

/**
 * Determine if error tracking should be enabled.
 *
 * Rules:
 * - Development + browser (local dev, Lovable) -> disabled
 * - Development + native (TestFlight) -> enabled
 * - Staging/Production -> always enabled
 */
function isEnabled(): boolean {
  const env = import.meta.env.MODE;
  if (env === 'development') {
    return Capacitor.isNativePlatform();
  }
  return true;
}

export function getErrorTrackerConfig(): ErrorTrackerConfig {
  return {
    dsn: import.meta.env.VITE_SENTRY_DSN || '',
    environment: import.meta.env.MODE,
    release: `want@${typeof __BUILD_TIMESTAMP__ !== 'undefined' ? __BUILD_TIMESTAMP__ : 'dev'}`,
    enabled: isEnabled(),
    enableNative: Capacitor.isNativePlatform(),
  };
}
